// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_ResetarAcessoPortalInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /clientes/resetar-acesso-portal
 *
 * Staff-facing: resets a customer's portal credential — invalidates whatever
 * activation code/session exists and mints a fresh activation code (ADR-0017).
 *
 * The body carries only the cliente_id, same reasoning as
 * Clientes_CriarAcessoPortalInput: the document is read from the cliente record
 * the caller is allowed to see, never accepted from the client.
 */
import { registerContract } from './validate'

export interface Clientes_ResetarAcessoPortalInput {
cliente_id: number
}

registerContract('Clientes_ResetarAcessoPortalInput', {
  cliente_id: { type: 'number',  required: true },
})
